<template>
  <LcCard body-class="pick-lottery-quick-pick-quantity flex items-center justify-between">
    <div>
      <h2 class="paragraph-bold">
        {{ $t('picklottery.quickpick.quantity.headline') }}
      </h2>
      <p class="paragraph-small-text text-secondary-secondary" :class="{ error: quantity > max }">
        {{ $t('picklottery.quickpick.quantity.hint', max) }}
      </p>
    </div>

    <div class="flex gap-100 items-center">
      <LcButton
        :aria-label="$t('picklottery.quickpick.quantity.arialabel.decrement')"
        class="button"
        :disabled="quantity <= EDITOR_QUICK_PICK_MIN_QUANTITY"
        icon="minus"
        size="medium"
        variant="tertiary"
        @click="quantity -= 1"
      />

      <LcInput
        v-bind="{ max }"
        v-model:value="quantity"
        class="input input-bold text-center"
        :min="EDITOR_QUICK_PICK_MIN_QUANTITY"
        no-feedback
        type="number"
      />

      <LcButton
        :aria-label="$t('picklottery.quickpick.quantity.arialabel.increment')"
        class="button"
        :disabled="quantity >= max"
        icon="plus"
        size="medium"
        variant="tertiary"
        @click="quantity += 1"
      />
    </div>
  </LcCard>
</template>

<script lang="ts" setup>
import { EDITOR_QUICK_PICK_MIN_QUANTITY } from '../constants/editor'

type Props = {
  max: number
}

defineProps<Props>()

const quantity = defineModel('value', { default: EDITOR_QUICK_PICK_MIN_QUANTITY, type: Number })
</script>

<style lang="scss" scoped>
.pick-lottery-quick-pick-quantity {
  .button {
    border: token('size/border/100') solid token('color/border/primary/primary');
    border-radius: token('size/radius/l');
    background-color: token('color/background/accent/info/info-extralight');

    &:disabled {
      border-color: token('color/background/secondary/secondary-disabled');
      background-color: token('color/background/primary/primary');
    }
  }

  .error {
    color: token('color/text/accent/accent-danger');
  }

  .input {
    width: 3.125rem;

    /* stylelint-disable-next-line selector-class-pattern */
    :deep(.lc-input__wrap) {
      padding: 0;
    }
  }
}
</style>
